import { render } from "./TagField.vue?vue&type=template&id=0b4207c4"
import script from "./TagField.vue?vue&type=script&lang=js"
export * from "./TagField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TagField.vue"]])

export default __exports__